module.exports = __webpack_public_path__ + "img/f2_img.526d540.png";